import { cn } from '@/shared/lib/utils'
import { Checkbox } from '@/components/ui/checkbox'

type NoPackagingDecisionRowProps = {
  checked: boolean
  disabled?: boolean
  label: string
  onCheckedChange?: (checked: boolean) => void
}

export function NoPackagingDecisionRow({
  checked,
  disabled = false,
  label,
  onCheckedChange,
}: NoPackagingDecisionRowProps) {
  return (
    <label
      className={cn(
        'flex items-start gap-2.5 rounded-lg border px-3.5 py-3',
        checked
          ? 'border-emerald-200 bg-emerald-50'
          : 'border-border bg-background',
        disabled ? 'cursor-default' : 'cursor-pointer'
      )}
    >
      <Checkbox
        checked={checked}
        disabled={disabled}
        className={cn('mt-0.5', checked && 'data-disabled:opacity-100')}
        onCheckedChange={(value) => {
          if (typeof value === 'boolean' && !disabled) {
            onCheckedChange?.(value)
          }
        }}
      />
      <span
        className={cn(
          'text-sm font-semibold',
          checked ? 'text-emerald-800' : 'text-foreground'
        )}
      >
        {label}
      </span>
    </label>
  )
}
